<h2>Datepicker Basic Examples</h2>

<div class="datepicker-grid">
	<div class="datepicker-column">
		<span class="label">Datepicker básico</span>
		<app-datepicker
			[formControl]="datepickerControl"
			placeholder="Selecciona una fecha..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'datepickerControl', placeholder: 'Selecciona una fecha...'})" />
	</div>
</div>

<h2>Datepicker Sizes</h2>

<div class="size-grid">
	<div class="size-column">
		<span class="label">Large (64px)</span>
		<app-datepicker
			[formControl]="datepickerControl"
			placeholder="Large datepicker..."
			size="large"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'datepickerControl', placeholder: 'Large datepicker...', size: 'large'})" />
	</div>

	<div class="size-column">
		<span class="label">Medium (56px)</span>
		<app-datepicker
			[formControl]="datepickerControl"
			placeholder="Medium datepicker..."
			size="medium"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'datepickerControl', placeholder: 'Medium datepicker...', size: 'medium'})" />
	</div>

	<div class="size-column">
		<span class="label">Small (48px)</span>
		<app-datepicker
			[formControl]="datepickerControl"
			placeholder="Small datepicker..."
			size="small"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'datepickerControl', placeholder: 'Small datepicker...', size: 'small'})" />
	</div>
</div>

<h2>Datepicker States</h2>

<div class="size-grid">
	<div class="size-column">
		<span class="label">Normal</span>
		<app-datepicker
			[formControl]="datepickerControl"
			placeholder="Seleccionar fecha..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'datepickerControl', placeholder: 'Seleccionar fecha...'})" />
	</div>

	<div class="size-column">
		<span class="label">Disabled</span>
		<app-datepicker
			[formControl]="disabledDatepickerControl"
			placeholder="Disabled datepicker..."
			[disabled]="true"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'disabledDatepickerControl', placeholder: 'Disabled datepicker...', disabled: true})" />
	</div>

	<div class="size-column">
		<span class="label">Error</span>
		<app-datepicker
			[formControl]="errorDatepickerControl"
			placeholder="Seleccionar fecha..."
			[error]="true"
			errorMessage="Este campo es obligatorio"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'errorDatepickerControl', placeholder: 'Seleccionar fecha...', error: true, errorMessage: 'Este campo es obligatorio'})" />
	</div>
</div>

<h2>Datepicker Range Mode</h2>

<div class="datepicker-grid">
	<div class="datepicker-column">
		<span class="label">Datepicker con rango de fechas</span>
		<app-datepicker
			[formControl]="rangeDatepickerControl"
			placeholder="Seleccionar rango de fechas..."
			[rangeMode]="true"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'rangeDatepickerControl', placeholder: 'Seleccionar rango de fechas...', rangeMode: true})" />
	</div>

	<div class="datepicker-column">
		<span class="label">Datepicker con rango (Large)</span>
		<app-datepicker
			[formControl]="rangeDatepickerControl"
			placeholder="Seleccionar rango..."
			size="large"
			[rangeMode]="true"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'rangeDatepickerControl', placeholder: 'Seleccionar rango...', size: 'large', rangeMode: true})" />
	</div>
</div>

<h2>Inline Datepicker</h2>

<div class="datepicker-grid">
	<div class="datepicker-column">
		<span class="label">Datepicker inline</span>
		<app-datepicker
			[formControl]="inlineDatepickerControl"
			[inline]="true"
			[eventDates]="eventDates"
			[requestDates]="requestDates"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'inlineDatepickerControl', inline: true, eventDates: 'eventDates', requestDates: 'requestDates'})" />
	</div>

	<div class="datepicker-column">
		<span class="label">Datepicker inline con rango</span>
		<app-datepicker
			[formControl]="inlineDatepickerControl"
			[inline]="true"
			[rangeMode]="true"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'inlineDatepickerControl', inline: true, rangeMode: true})" />
	</div>
</div>

<h2>Week View Datepicker</h2>

<div class="datepicker-grid">
	<div class="datepicker-column">
		<span class="label">Vista semanal (7 días)</span>
		<app-datepicker
			[formControl]="weekViewControl"
			[inline]="true"
			view="week"
			[numberOfDays]="7"
			[eventDates]="eventDates"
			[requestDates]="requestDates"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'weekViewControl', inline: true, view: 'week', numberOfDays: 7, eventDates: 'eventDates', requestDates: 'requestDates'})" />
	</div>
</div>

<h2>Datepicker with Time Inputs</h2>

<div class="datepicker-grid">
	<div class="datepicker-column">
		<span class="label">Datepicker con selección de hora</span>
		<app-datepicker
			[formControl]="timeDatepickerControl"
			placeholder="Seleccionar fecha y hora..."
			[showTimeInputs]="true"
			[useSpecialContainer]="true"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'timeDatepickerControl', placeholder: 'Seleccionar fecha y hora...', showTimeInputs: true, useSpecialContainer: true})" />
	</div>
</div>

<h2>Datepicker with Special Container</h2>

<div class="datepicker-grid">
	<div class="datepicker-column">
		<span class="label">Con contenedor especial (fecha única)</span>
		<app-datepicker
			[formControl]="datepickerControl"
			placeholder="Seleccionar fecha..."
			[useSpecialContainer]="true"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'datepickerControl', placeholder: 'Seleccionar fecha...', useSpecialContainer: true})" />
	</div>

	<div class="datepicker-column">
		<span class="label">Con contenedor especial (rango)</span>
		<app-datepicker
			[formControl]="rangeDatepickerControl"
			placeholder="Seleccionar rango..."
			[rangeMode]="true"
			[useSpecialContainer]="true"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'rangeDatepickerControl', placeholder: 'Seleccionar rango...', rangeMode: true, useSpecialContainer: true})" />
	</div>
</div>
